import { DefaultValues, useForm, UseFormOptions } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import { TCarrierOptionSchema, CarrierOptionSchema } from '../schema/CarrierOptionSchema'

export const getDefaultValues = <TCarrierOptionSchema>(
  values: DefaultValues<TCarrierOptionSchema>
) => {
  return CarrierOptionSchema.cast({
    ...values,
  })
}

export interface IUseCarrierOptionFormContext {
  /**
   * Used to require sourceChannel and sourceSegment fields
   */
  isSourceFieldsRequired: boolean
}

interface IUseCarrierOptionFormProps
  extends Omit<UseFormOptions<TCarrierOptionSchema, IUseCarrierOptionFormContext>, 'resolver'> {}

export const useCarrierOptionForm = ({
  defaultValues = {},
  context = { isSourceFieldsRequired: false },
  ...props
}: IUseCarrierOptionFormProps = {}) => {
  return useForm({
    context,
    resolver: yupResolver(CarrierOptionSchema),
    shouldUnregister: false,
    defaultValues: getDefaultValues(defaultValues),
    ...props,
  })
}

export default useCarrierOptionForm
